import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SellReadyMessage } from './config.js';

import './index.scss';

class ReadyToSell extends React.Component {
  constructor(props) {
    super(props);
  }

  scrollToTop = () => {
    const sellSearch = document.querySelector('.sellSearch input');
    sellSearch ? sellSearch.focus() : null;
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <div className="ReadyToSell__container">
        <div className="ReadyToSell__title">
          <FormattedMessage {...SellReadyMessage.title} />
        </div>
        <button className="ReadyToSell__button" onClick={this.scrollToTop}>
          <FormattedMessage {...SellReadyMessage.buttonlabel} />
        </button>
      </div>
    );
  }
}

export default ReadyToSell;
